<template>
  <div class="editor-container">
    <quill-editor
      id="editor"
      class="ql-editor"
      ref="myTextEditor"
      v-model="content"
      :options="editorOption"
      :disabled="editor_disabled"
      @change="onEditorChange($event)"
    ></quill-editor>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor, Quill } from 'vue-quill-editor'
// 设置字体大小
let fontSizeStyle = Quill.import('attributors/style/size') // 引入这个后会把样式写在style上
fontSizeStyle.whitelist = ['14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '36px', '48px', '72px']
Quill.register(fontSizeStyle, true)
// 设置字体样式
let Font = Quill.import('attributors/style/font') // 引入这个后会把样式写在style上
let fonts = [false, 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial']
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)
import { BASEURL } from '@/axios/baseUrlConfig.js'

export default {
  name: 'editor',
  data() {
    return {
      content: '',
      // editorHeight: '',
      editorOption: {
        modules: {
          toolbar: [
            // 加粗 斜体 下划线 删除线
            ['bold', 'italic', 'underline', 'strike'],
            // 颜色
            [{ color: [] }, { background: [] }],
            // 标题
            [{ header: 1 }, { header: 2 }],
            // 对齐方式
            [{ align: [] }],
            // 文字大小
            // [{ size: ['small', 'Normal', 'large', 'huge'] }],
            [{ size: ['14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '36px', '48px', '72px'] }], // 字体大小
            // font family
            // [{ font: [] }],
            [{ font: ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }], // 字体
            // 列表
            [{ list: 'ordered' }, { list: 'bullet' }],
            // 上标下标
            [{ script: 'sub' }, { script: 'super' }],
            // 文本方向
            [{ direction: 'rtl' }],
            // 引用 代码
            ['blockquote', 'code-block']
          ]
        },
        placeholder: '编辑文章内容'
      },
      // 是否显示进度
      showProress: false,
      // 当前显示进度字符串
      processStr: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    editorHeight: {
      type: String,
      default: '100px'
    },
    value: {
      type: String,
      default: ''
    },
    editor_disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.init()
    this.$refs.myTextEditor.quill.container.style.height = this.editorHeight
    this.editorOption = {
      placeholder: '编辑文章内容'
    }
  },
  methods: {
    //  自定义粘贴图片功能
    init() {
      let quill = this.$refs.myTextEditor.quill
      quill.root.addEventListener(
        'paste',
        evt => {
          if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
            evt.preventDefault()
            ;[].forEach.call(evt.clipboardData.files, file => {
              if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                return
              }
              this.uploadToServer(file)
            })
          }
        },
        false
      )
    },
    // 修改粘贴图片为上传到服务器
    uploadToServer(file) {
      const that = this
      that.uploadSingle(file)
      // let quill = this.$refs.myTextEditor.quill
      // let length = quill.getSelection(true).index
      // //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
      // quill.insertEmbed(length, 'image', '')
      // quill.setSelection(length + 1)
    },
    // 获取guid
    guid() {
      var guid = ''
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) guid += '-'
      }
      return guid
    },
    // 上传一个文件
    async uploadSingle(fileObj) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const that = this
      const guID = that.guid()
      let formData = new FormData()
      formData.append('file', fileObj)
      formData.append('vuePathName', '')
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept-language': 'zh-CN'
        },
        timeout: 0
      }
      const { data: res } = await that.$http.post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
      if (res.isSuccess) {
        that.uploadComplete(res.data)
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 上传完毕后
    uploadComplete(data) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      let quill = this.$refs.myTextEditor.quill
      let length = quill.getSelection(true).index
      //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
      quill.insertEmbed(length, 'image', `${upload}/downloadnew/${data.aPath}`)
      quill.setSelection(length + 1)
    },
    // change事件
    onEditorChange({ html }) {
      this.content = html
      this.$emit('change', this.content)
    }
  },
  components: {
    quillEditor
  },
  watch: {
    value: {
      handler(newVal) {
        this.content = newVal
      },
      immediate: true
    },
    editorHeight: {
      handler(newValue) {
        this.$refs.myTextEditor.quill.container.style.height = newValue
      }
    }
  }
}
</script>

<style lang="less" scoped>
#editor {
  // margin-top: 30px;
  margin: -10px 10px 0 0 !important;
}
.ql-editor {
  padding: 0 !important;
  // margin: 0 !important;
}
.quill-editor {
  /deep/ .ql-picker.ql-font .ql-picker-label[data-value='SimSun']::before,
  /deep/ .ql-picker.ql-font .ql-picker-item[data-value='SimSun']::before {
    content: '宋体';
    font-family: 'SimSun' !important;
  }
  /deep/ .ql-picker.ql-font .ql-picker-label[data-value='SimHei']::before,
  /deep/ .ql-picker.ql-font .ql-picker-item[data-value='SimHei']::before {
    content: '黑体';
    font-family: 'SimHei';
  }
  /deep/ .ql-picker.ql-font .ql-picker-label[data-value='Microsoft-YaHei']::before,
  /deep/ .ql-picker.ql-font .ql-picker-item[data-value='Microsoft-YaHei']::before {
    content: '微软雅黑';
    font-family: 'Microsoft YaHei';
  }
  /deep/ .ql-picker.ql-font .ql-picker-label[data-value='KaiTi']::before,
  /deep/ .ql-picker.ql-font .ql-picker-item[data-value='KaiTi']::before {
    content: '楷体';
    font-family: 'KaiTi' !important;
  }
  /deep/ .ql-picker.ql-font .ql-picker-label[data-value='FangSong']::before,
  /deep/ .ql-picker.ql-font .ql-picker-item[data-value='FangSong']::before {
    content: '仿宋';
    font-family: 'FangSong';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='14px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='14px']::before {
    content: '14px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='16px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='16px']::before {
    content: '16px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='18px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='18px']::before {
    content: '18px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='20px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='20px']::before {
    content: '20px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='22px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='22px']::before {
    content: '22px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='24px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='24px']::before {
    content: '24px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='26px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='26px']::before {
    content: '26px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='28px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='28px']::before {
    content: '28px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='36px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='36px']::before {
    content: '36px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='48px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='48px']::before {
    content: '48px';
  }
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='72px']::before,
  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='72px']::before {
    content: '72px';
  }
}
</style>
